/** 节流：适合 scroll / resize，默认 100ms（与 render 规则一致） */
export function throttle<T extends unknown[]>(
  fn: (...args: T) => void,
  waitMs = 100,
): (...args: T) => void {
  let last = 0
  let timer: ReturnType<typeof setTimeout> | null = null
  return (...args: T) => {
    const now = Date.now()
    const remaining = waitMs - (now - last)
    if (remaining <= 0) {
      if (timer) {
        clearTimeout(timer)
        timer = null
      }
      last = now
      fn(...args)
    } else if (!timer) {
      timer = setTimeout(() => {
        timer = null
        last = Date.now()
        fn(...args)
      }, remaining)
    }
  }
}
